import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "../constants";
import { CouponsAnalyticsExtraParams } from "@cart-client/interfaces/Coupon";

type ContextData = { headerString?: string; subHeadString?: string; couponType?: string };

export const impressionSavingsCornerLineItem = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: number | string,
    data: ContextData,
    extraParams: CouponsAnalyticsExtraParams = {},
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SAVINGS_CORNER_EXTRA_SAVINGS,
        extraParams: JSON.stringify({ cartId, ...(extraParams ?? {}) }),
        context: JSON.stringify({ ...(data ?? {}) }),
    });
};

export const impressionSavingsCornerHabitRewardUnlock = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: number | string,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    data: { habit_form_title?: string; habit_form_subtitle?: string },
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SAVINGS_CORNER_HABIT_UNLOCK,
        extraParams: JSON.stringify({ cartId }),
        context: JSON.stringify(data),
    });
};

export const clickSavingsCornerHabitViewReward = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartId: number | string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SAVINGS_CORNER_HABIT_VIEW_REWARD,
        extraParams: JSON.stringify({ cartId }),
    });
};

export const impressionDualApplicationCapability = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId: number | string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_DUAL_APPLICATION_CAPABILITY,
        extraParams: JSON.stringify({ cartId }),
    });
};
